/**
 * getAvatarUrl returns the correct URL to use for a user's avatar.
 *
 * This will either be `user.authorBio.gravator` or
 * `user.avatar.url` depending on which is supplied.
 *
 * The `avatarPrefix` appConfig variable is used as
 * the default gravatarPrefix, but it can be overriden by the `gravatarPrefix` parameter.
 * @param {Object} user user object
 * @param {string} gravatarPrefix prefix to use for gravatar
 * @returns {string} avatar URL
 */
const getUserAvatarUrl = (user, gravatarPrefix) => {
  let avatarUrl = '';
  // When there is no gravatar URL, try and use the other one.
  // This is necessary because some users have one and not the other.
  if (
    !user.authorBio ||
    user.authorBio.gravatar === null ||
    user.authorBio.gravatar === ''
  ) {
    avatarUrl = user.avatar && user.avatar.url;
  } else {
    avatarUrl = `${gravatarPrefix}/${user.authorBio.gravatar}`;
  }

  return avatarUrl;
};

export { getUserAvatarUrl };
export default getUserAvatarUrl;
